// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAccountReportBody = {
  reportedAccountId: string;
  reason: "spam" | "harassment" | "hate" | "other";
  details?: string | null;
  chatId?: string | null;
};

export type typeAccountReportOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { reportId: string };
};

export type typeAccountReportOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAccountReportOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAccountReportOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAccountReportBody = {
  type: "object",
  properties: {
    reportedAccountId: { type: "string", maxLength: 3000, minLength: 1 },
    reason: { type: "string", enum: ["spam", "harassment", "hate", "other"] },
    details: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    chatId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["reportedAccountId", "reason"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAccountReport(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAccountReportBody);
  }

  return async function postAccountReport(
    payload: typeAccountReportBody,
  ): Promise<typeAccountReportOutput200 | typeAccountReportOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAccountReport" failed before calling the network. #c441278e8405`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#c441278e8405" },
        },
        data: null,
      } as typeAccountReportOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/account/report`,
      httpMethod: "POST",
      options,
    })) as typeAccountReportOutput200 | typeAccountReportOutput400;
  };
}
